import { FC } from 'react';
import { useSelector } from 'react-redux';
import { InlineFilter } from 'shared/components/InlineFilter';
import { RangeInput } from 'shared/components/RangeInput';
import { useDebouncedCallback, useFilterChangeCallback } from 'shared/hooks';
import { selectLandAreaFilter } from 'shared/selectors/advancedFilters';

export const LandAreaContainer: FC = () => {
  const { label, valueMax, valueMin, max, min } = useSelector(selectLandAreaFilter);

  const onChange = useFilterChangeCallback();

  const handleMinChange = useDebouncedCallback((newValue: number | null) => {
    onChange({ action: 'setLandAreaMin', arguments: [newValue] });
  });

  const handleMaxChange = useDebouncedCallback((newValue: number | null) => {
    onChange({ action: 'setLandAreaMax', arguments: [newValue] });
  });

  return (
    <InlineFilter width={100} postfix={'м\u00b2'} label={label} dataTestId="landArea">
      <RangeInput
        min={min}
        max={max}
        valueMin={valueMin}
        valueMax={valueMax}
        onChangeMin={handleMinChange}
        onChangeMax={handleMaxChange}
      />
    </InlineFilter>
  );
};
